import React from 'react';
import Chip from './../chip/';
import './index.css';

/* eslint-disable camelcase */
export default (props) => {
  const { dashboard_label, title, details, type } = props;
  const { time, cal, distance } = (details || {});
  return (<div className="featured-content-card">
    <h1>{ title }</h1>
    <div className="category">
      <Chip>{ dashboard_label || type }</Chip>
    </div>
    {
      distance
      || time
      || cal
        ? <ul>
          { distance ? <li>{ distance }</li> : null }
          { time ? <li>{ time }</li> : null }
          { cal ? <li>{ cal }</li> : null }
        </ul>
        : null
    }
  </div>);
};
/* eslint-enable camelcase */


// WEBPACK FOOTER //
// ./src/components/featured-content-card/index.jsx